<template>
    <v-select
        @input="onChangeHandler"
        :options="propertyList"
        :value="value.length > 0 ? value : null"
        :reduce="option => option.value"
        :placeholder="placeholder"
        :multiple="multiple"
        :clearable="clearable"
        :disabled="disabled"
        label="label"
    >
        <template slot="option" slot-scope="option">
            <div class="d-flex py-1">
                <p class="mb-0">{{ option.label }}</p>
            </div>
        </template>
    </v-select>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: 'Select property'
        },

        propertyList: {
            type: Array,
            default: null
        },

        value: {
            default: null
        },

        multiple: {
            type: Boolean,
            default: true
        },

        clearable: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        onChangeHandler(value) {
            this.$emit('select', value)
        }
    }
}
</script>
